(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.sub
  (:require
   [re-frame.core :as rf]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [common.schema.entities.lp-portal.lp-report :as lp-report]
   [common.schema.entities.lp-portal.lp-report-holding :as lp-report-holding]))

(def gathering-path (conj editor-sub/editor-path :data-gathering))
(def gathering-mode-path (conj gathering-path :mode))
(def selected-tab-path (conj editor-sub/editor-path :selected-tab))
(def gathering-holding-path (conj gathering-path :holding-report-id))
(def gathering-fund-path (conj gathering-path :fund-report-id))
(def gathering-feeder-path (conj gathering-path :feeder-report-id))
(def add-contacts-path (conj gathering-path :add-contact-context))
(def add-contact-processing-path (conj gathering-path :processing-create-contact))
(def add-contact-error-path (conj gathering-path :contact-create-error))
(def edit-contact-path (conj gathering-path :edit-contact-context))
(def edit-contact-processing-path (conj gathering-path :processing-edit-contact))
(def edit-contact-error-path (conj gathering-path :edit-contact-error))
(def delete-contacts-path (conj gathering-path :delete-contact-context))
(def delete-contact-error-path (conj gathering-path :contact-remove-error))
(def delete-contact-processing-path (conj gathering-path :processing-delete-contact))
(def add-commitment-to-crm-processing-path (conj gathering-path :add-commitment-to-crm-processing))
(def uploads-path (conj gathering-path :uploads))
(def private-material-bulk-upload-path (conj gathering-path :private-material-bulk-upload))
(def rich-content-list-path (conj gathering-path :report-rich-content-list))
(def feeder-rich-content-list-path (conj gathering-path :feeder-report-rich-content-list))
(def holdings-rich-content-list-path (conj gathering-path :holdings-report-rich-content-list))

(rf/reg-sub
 ::private-material-bulk-upload
 (fn [db]
   (get-in db private-material-bulk-upload-path)))

(rf/reg-sub
 ::fund-text-rejected?
 (fn [db]
   (get-in db [::fund-text-rejected?])))

(rf/reg-sub
 ::fund-text-submitted?
 (fn [db]
   (get-in db [::fund-text-submitted?])))

(rf/reg-sub
 ::fund-data-rejected?
 (fn [db]
   (get-in db [::fund-data-rejected?])))

(rf/reg-sub
 ::fund-data-submitted?
 (fn [db]
   (get-in db [::fund-data-submitted?])))

(rf/reg-sub
 ::holding-text-rejected?
 (fn [db]
   (get-in db [::holding-text-rejected?])))

(rf/reg-sub
 ::holding-text-submitted?
 (fn [db]
   (get-in db [::holding-text-submitted?])))

(rf/reg-sub
 ::holding-data-rejected?
 (fn [db]
   (get-in db [::holding-data-rejected?])))

(rf/reg-sub
 ::holding-data-submitted?
 (fn [db]
   (get-in db [::holding-data-submitted?])))

(rf/reg-sub
 ::text-reject-recipients
 (fn [db [_ report-id]]
   (let [master-report (get-in db editor-sub/report-path)
         report (editor-sub/get-main-or-feeder-report master-report db report-id)
         contributors (:lp-report/text-contributors report)
         accounts (->> (get-in db editor-sub/accounts-path)
                       (filter (fn [{:keys [db/id]}]
                                 (some #{id} contributors)))
                       (seq))]
     accounts)))

(rf/reg-sub
 ::text-submit-recipients
 (fn [db [_ report-id]]
   (let [master-report (get-in db editor-sub/report-path)
         report (editor-sub/get-main-or-feeder-report master-report db report-id)
         text-approver (:lp-report/text-approver report)
         accounts (->> (get-in db editor-sub/accounts-path)
                       (filter (fn [{:keys [db/id]}]
                                 (some #{id} [text-approver])))
                       (seq))]
     accounts)))

(rf/reg-sub
 ::data-reject-recipients
 (fn [db [_ report-id]]
   (let [master-report (get-in db editor-sub/report-path)
         report (editor-sub/get-main-or-feeder-report master-report db report-id)
         contributors (:lp-report/data-contributors report)
         accounts (->> (get-in db editor-sub/accounts-path)
                       (filter (fn [{:keys [db/id]}]
                                 (some #{id} contributors)))
                       (seq))]
     accounts)))

(rf/reg-sub
 ::data-submit-recipients
 (fn [db [_ report-id]]
   (let [master-report (get-in db editor-sub/report-path)
         report (editor-sub/get-main-or-feeder-report master-report db report-id)
         text-approver (:lp-report/data-approver report)
         accounts (->> (get-in db editor-sub/accounts-path)
                       (filter (fn [{:keys [db/id]}]
                                 (some #{id} [text-approver])))
                       (seq))]
     accounts)))

(rf/reg-sub
 ::holding-data-reject-recipients
 (fn [db [_ report-id]]
   (let [report (get-in db (conj editor-sub/holdings-path report-id))
         contributors (:lp-report-holding/data-contributors report)
         accounts (->> (get-in db editor-sub/accounts-path)
                       (filter (fn [{:keys [db/id]}]
                                 (some #{id} contributors)))
                       (seq))]
     accounts)))

(rf/reg-sub
 ::holding-data-submit-recipients
 (fn [db [_ report-id]]
   (let [report (get-in db (conj editor-sub/holdings-path report-id))
         text-approver (:lp-report-holding/data-approver report)
         accounts (->> (get-in db editor-sub/accounts-path)
                       (filter (fn [{:keys [db/id]}]
                                 (some #{id} [text-approver])))
                       (seq))]
     accounts)))

(rf/reg-sub
 ::holding-text-reject-recipients
 (fn [db [_ report-id]]
   (let [report (get-in db (conj editor-sub/holdings-path report-id))
         contributors (:lp-report-holding/text-contributors report)
         accounts (->> (get-in db editor-sub/accounts-path)
                       (filter (fn [{:keys [db/id]}]
                                 (some #{id} contributors)))
                       (seq))]
     accounts)))

(rf/reg-sub
 ::holding-text-submit-recipients
 (fn [db [_ report-id]]
   (let [report (get-in db (conj editor-sub/holdings-path report-id))
         text-approver (:lp-report-holding/text-approver report)
         accounts (->> (get-in db editor-sub/accounts-path)
                       (filter (fn [{:keys [db/id]}]
                                 (some #{id} [text-approver])))
                       (seq))]
     accounts)))
(defn permissions-ctx
  [db]
  (let [report (get-in db editor-sub/report-path)
        account-id (get-in db editor-sub/account-id-path)
        admin? (get-in db editor-sub/reporting-admin?-path)
        owner? (some #{account-id}
                     (:lp-report/process-owners report))]
    {:fund-report     report
     :account-id      account-id
     :team-ids        (get-in db editor-sub/team-memberships-ids-path)
     :admin-or-owner? (or owner? admin?)}))

(defn feeder-permissions-ctx
  [db]
  (let [master-report (get-in db editor-sub/report-path)
        feeder-report (first (get-in db editor-sub/feeder-reports-path))
        account-id (get-in db editor-sub/account-id-path)
        admin? (get-in db editor-sub/reporting-admin?-path)
        owner? (some #{account-id}
                     (:lp-report/process-owners master-report))]
    {:fund-report     feeder-report
     :master-report   master-report
     :account-id      account-id
     :team-ids        (get-in db editor-sub/team-memberships-ids-path)
     :admin-or-owner? (or owner? admin?)}))

(rf/reg-sub
 ::has-edit-fund-texts-access?
 (fn [db]
   (let [report (get-in db editor-sub/report-path)
         ctx (permissions-ctx db)
         edit-access? (lp-report/can-edit-text? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? edit-access?]
     (case (:lp-report/step report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       nil))))

(rf/reg-sub
 ::has-edit-fund-data-access?
 (fn [db]
   (let [report (get-in db editor-sub/report-path)
         ctx (permissions-ctx db)
         account-id (get-in db editor-sub/account-id-path)
         admin? (get-in db editor-sub/reporting-admin?-path)
         update-access? (lp-report/can-update-data? {:account-id    account-id
                                                     :admin?        admin?
                                                     :fund-report   report
                                                     :master-report report})
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? update-access?]
     (case (:lp-report/step report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)))))

(rf/reg-sub
 ::can-edit-fund-texts?
 (fn [db]
   (let [report (get-in db editor-sub/report-path)
         ctx (permissions-ctx db)
         edit-access? (lp-report/can-edit-text? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? (and edit-access?
                        (not= (:lp-report/text-status report)
                              :lp-report.publishing-status/approved))]
     (case (:lp-report/step report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       nil))))

(rf/reg-sub
 ::can-edit-fund-footer-texts?
 (fn [db]
   (let [report (get-in db editor-sub/report-path)
         ctx (permissions-ctx db)
         edit-access? (lp-report/can-edit-footers? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? (and edit-access?
                        (or (not= (:lp-report/text-status report)
                                  :lp-report.publishing-status/approved)
                            (not= (:lp-report/data-status report)
                                  :lp-report.publishing-status/approved)))]
     (case (:lp-report/step report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)))))

(rf/reg-sub
 ::can-approve-report-texts?
 (fn [db]
   (let [report (get-in db editor-sub/report-path)
         ctx (permissions-ctx db)
         approve-access? (lp-report/can-approve-text? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? approve-access?]
     (case (:lp-report/step report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)))))

(rf/reg-sub
 ::can-update-report-data?
 (fn [db]
   (let [report (get-in db editor-sub/report-path)
         ctx (permissions-ctx db)
         account-id (get-in db editor-sub/account-id-path)
         admin? (get-in db editor-sub/reporting-admin?-path)
         update-access? (lp-report/can-update-data? {:account-id    account-id
                                                     :admin?        admin?
                                                     :fund-report   report
                                                     :master-report report})
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? (and update-access?
                        (not= (:lp-report/data-status report)
                              :lp-report.publishing-status/approved))]
     (case (:lp-report/step report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)))))

(rf/reg-sub
 ::can-approve-report-data?
 (fn [db]
   (let [report (get-in db editor-sub/report-path)
         ctx (permissions-ctx db)
         approve-access? (lp-report/can-approve-data? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? approve-access?]
     (case (:lp-report/step report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)))))

(rf/reg-sub
 ::has-edit-feeder-texts-access?
 (fn [db]
   (let [master-report (get-in db editor-sub/report-path)
         ctx (feeder-permissions-ctx db)
         edit-access? (lp-report/can-edit-text? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? edit-access?]
     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)))))

(rf/reg-sub
 ::can-edit-feeder-texts?
 (fn [db]
   (let [feeder-report (first (get-in db editor-sub/feeder-reports-path))
         master-report (get-in db editor-sub/report-path)
         ctx (feeder-permissions-ctx db)
         edit-access? (lp-report/can-edit-text? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? (and edit-access?
                        (not= (:lp-report/text-status feeder-report)
                              :lp-report.publishing-status/approved))]
     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)))))

(rf/reg-sub
 ::can-edit-feeder-footer-texts?
 (fn [db]
   (let [feeder-report (first (get-in db editor-sub/feeder-reports-path))
         master-report (get-in db editor-sub/report-path)
         ctx (permissions-ctx db)
         edit-access? (lp-report/can-edit-footers? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? (and edit-access?
                        (or (not= (:lp-report/text-status feeder-report)
                                  :lp-report.publishing-status/approved)
                            (not= (:lp-report/data-status feeder-report)
                                  :lp-report.publishing-status/approved)))]
     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       (js/console.log "unknown step" (:lp-report/step master-report))))))

(rf/reg-sub
 ::can-approve-feeder-texts?
 (fn [db]
   (let [master-report (get-in db editor-sub/report-path)
         ctx (feeder-permissions-ctx db)
         approve-access? (lp-report/can-approve-text? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? approve-access?]
     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       (js/console.log "unknown step" (:lp-report/step master-report))))))

(rf/reg-sub
 ::has-edit-feeder-data-access?
 (fn [db]
   (let [feeder-report (first (get-in db editor-sub/feeder-reports-path))
         master-report (get-in db editor-sub/report-path)
         account-id (get-in db editor-sub/account-id-path)
         admin? (get-in db editor-sub/reporting-admin?-path)
         approve-access? (lp-report/can-update-data? {:account-id    account-id
                                                      :admin?        admin?
                                                      :fund-report   feeder-report
                                                      :master-report master-report})
         admin-or-owner? (or admin?
                             (some #{account-id} (:lp-report/process-owners feeder-report))
                             (some #{account-id} (:lp-report/process-owners master-report)))
         can-edit? approve-access?]
     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       (js/console.log "unknown step" (:lp-report/step master-report))))))

(rf/reg-sub
 ::can-update-feeder-data?
 (fn [db]
   (let [feeder-report (first (get-in db editor-sub/feeder-reports-path))
         master-report (get-in db editor-sub/report-path)
         account-id (get-in db editor-sub/account-id-path)
         admin? (get-in db editor-sub/reporting-admin?-path)
         approve-access? (lp-report/can-update-data? {:account-id    account-id
                                                      :admin?        admin?
                                                      :fund-report   feeder-report
                                                      :master-report master-report})
         admin-or-owner? (or admin?
                             (some #{account-id} (:lp-report/process-owners feeder-report))
                             (some #{account-id} (:lp-report/process-owners master-report)))
         can-edit? (and approve-access?
                        (not= (:lp-report/data-status feeder-report)
                              :lp-report.publishing-status/approved))]
     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       (js/console.log "unknown step" (:lp-report/step master-report))))))

(rf/reg-sub
 ::can-approve-feeder-data?
 (fn [db]
   (let [master-report (get-in db editor-sub/report-path)
         ctx (feeder-permissions-ctx db)
         approve-access? (lp-report/can-approve-data? ctx)
         admin-or-owner? (:admin-or-owner? ctx)
         can-edit? approve-access?]
     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       (js/console.log "unknown step" (:lp-report/step master-report))))))

(rf/reg-sub
 ::can-approve-holding-report-text?
 (fn [db [_ report-id]]
   (let [ctx (permissions-ctx db)
         holding-report (get-in db (conj editor-sub/holdings-path report-id))
         approve-access? (lp-report-holding/can-approve-text? (assoc ctx
                                                                     :holding-report
                                                                     holding-report))]
     approve-access?)))

(rf/reg-sub
 ::can-approve-holding-data?
 (fn [db [_ report-id]]
   (let [ctx (permissions-ctx db)
         holding-report (get-in db (conj editor-sub/holdings-path report-id))
         approve-access? (lp-report-holding/can-approve-data? (assoc ctx
                                                                     :holding-report
                                                                     holding-report))]
     approve-access?)))

(rf/reg-sub
 ::can-edit-holding-texts?
 (fn [db [_ holding-id]]
   (let [ctx (permissions-ctx db)
         admin-or-owner? (:admin-or-owner? ctx)
         master-report (:fund-report ctx)
         holding-report (get-in db (conj editor-sub/holdings-path holding-id))
         edit-access? (lp-report-holding/can-edit-text? (assoc ctx
                                                               :holding-report
                                                               holding-report))
         can-edit? (and edit-access?
                        (not= (:lp-report-holding/text-status holding-report)
                              :lp-report-holding.publishing-status/approved))]

     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       (js/console.log "unknown step" (:lp-report/step master-report))))))

(rf/reg-sub
 ::can-edit-holding-footers?
 (fn [db [_ holding-id]]
   (let [ctx (permissions-ctx db)
         admin-or-owner? (:admin-or-owner? ctx)
         master-report (:fund-report ctx)
         holding-report (get-in db (conj editor-sub/holdings-path holding-id))
         edit-access? (lp-report-holding/can-edit-footers? (assoc ctx
                                                                  :holding-report
                                                                  holding-report))
         can-edit? (and edit-access?
                        (or (not= (:lp-report-holding/text-status holding-report)
                                  :lp-report-holding.publishing-status/approved)
                            (not= (:lp-report-holding/data-status holding-report)
                                  :lp-report-holding.publishing-status/approved)))]

     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       nil))))

(rf/reg-sub
 ::can-edit-holding-chart?
 (fn [db [_ holding-id]]
   (let [ctx (permissions-ctx db)
         admin-or-owner? (:admin-or-owner? ctx)
         master-report (:fund-report ctx)
         holding-report (get-in db (conj editor-sub/holdings-path holding-id))
         edit-access? (lp-report-holding/can-edit-chart? (assoc ctx
                                                                :holding-report
                                                                holding-report))
         can-edit? (and edit-access?
                        (or (not= (:lp-report-holding/text-status holding-report)
                                  :lp-report-holding.publishing-status/approved)
                            (not= (:lp-report-holding/data-status holding-report)
                                  :lp-report-holding.publishing-status/approved)))]

     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       nil))))

(rf/reg-sub
 ::can-select-holding-chart?
 (fn [db [_ holding-id]]
   (let [ctx (permissions-ctx db)
         admin-or-owner? (:admin-or-owner? ctx)
         master-report (:fund-report ctx)
         holding-report (get-in db (conj editor-sub/holdings-path holding-id))
         edit-access? (lp-report-holding/can-select-data-set? (assoc ctx
                                                                     :holding-report
                                                                     holding-report))
         can-edit? (and edit-access?
                        (or (not= (:lp-report-holding/text-status holding-report)
                                  :lp-report-holding.publishing-status/approved)
                            (not= (:lp-report-holding/data-status holding-report)
                                  :lp-report-holding.publishing-status/approved)))]

     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       nil))))

(rf/reg-sub
 ::can-edit-holding-data?
 (fn [db [_ holding-id]]
   (let [ctx (permissions-ctx db)
         admin-or-owner? (:admin-or-owner? ctx)
         master-report (:fund-report ctx)
         holding-report (get-in db (conj editor-sub/holdings-path holding-id))
         edit-access? (lp-report-holding/can-update-data? (assoc ctx
                                                                 :holding-report
                                                                 holding-report))
         can-edit? (and edit-access?
                        (not= (:lp-report-holding/data-status holding-report)
                              :lp-report-holding.publishing-status/approved))]

     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       nil))))

(rf/reg-sub
 ::ongoing-uploads
 (fn [db _]
   (get-in db uploads-path)))

(rf/reg-sub
 ::can-edit-any-holdings-data?
 (fn [db _]
   (let [ctx (permissions-ctx db)
         admin-or-owner? (:admin-or-owner? ctx)
         master-report (:fund-report ctx)
         can-edit?
         (->> master-report
              :lp-report/holdings
              (some (fn [holding-id]
                      (let [holding-report (get-in db (conj editor-sub/holdings-path holding-id))
                            edit-access? (lp-report-holding/can-update-data? (assoc ctx
                                                                                    :holding-report
                                                                                    holding-report))
                            can-edit? (and edit-access?
                                           (not= (:lp-report-holding/data-status holding-report)
                                                 :lp-report-holding.publishing-status/approved))]
                        can-edit?))))]

     (case (:lp-report/step master-report)
       :lp-report.step/initialization false
       :lp-report.step/data-gathering can-edit?
       :lp-report.step/review can-edit?
       :lp-report.step/pending-approval can-edit?
       :lp-report.step/approved (and can-edit? admin-or-owner?)
       :lp-report.step/publishing-queue (and can-edit? admin-or-owner?)
       :lp-report.step/published (and can-edit? admin-or-owner?)
       :lp-report.step/archived (and can-edit? admin-or-owner?)
       nil))))

(rf/reg-sub
 ::gathering-mode
 (fn [db]
   (get-in db gathering-mode-path)))

(rf/reg-sub
 ::selected-tab
 (fn [db [_ accessible-tabs]]
   (or (some #{(get-in db selected-tab-path)} accessible-tabs)
       (first accessible-tabs))))

(rf/reg-sub
 ::add-contact-context
 (fn [db]
   (get-in db add-contacts-path)))

(rf/reg-sub
 ::edit-contact-context
 (fn [db]
   (get-in db edit-contact-path)))

(rf/reg-sub
 ::delete-contact-context
 (fn [db]
   (get-in db delete-contacts-path)))

(rf/reg-sub
 ::delete-contact-error
 (fn [db]
   (get-in db delete-contact-error-path)))

(rf/reg-sub
 ::edit-contact-error
 (fn [db]
   (get-in db edit-contact-error-path)))

(rf/reg-sub
 ::create-contact-error
 (fn [db]
   (get-in db [:lp-report-editor :data-gathering :contact-create-error])))

(rf/reg-sub
 ::fund-report-id
 (fn [db]
   (get-in db [:lp-report-editor :data-gathering :fund-report-id])))

(rf/reg-sub
 ::holding-report-id
 (fn [db]
   (get-in db [:lp-report-editor :data-gathering :holding-report-id])))

(rf/reg-sub
 ::holding-report
 (fn [db [_ holding-id]]
   (get-in db (conj editor-sub/holdings-path holding-id))))

(rf/reg-sub
 ::report-rich-content-list
 (fn [db [_]]
   (get-in db rich-content-list-path)))

(defn resolve-submit-for-review-text
  [report-rich-content-list]
  (let [count-of-all (count report-rich-content-list)
        completed (->> report-rich-content-list
                       (filter :completed?)
                       (count))]
    (str " (" completed "/" count-of-all ")")))

(rf/reg-sub
 ::rich-text-completed-amount
 :<-
 [::report-rich-content-list]
 (fn [report-rich-content-list _]
   (resolve-submit-for-review-text report-rich-content-list)))

(rf/reg-sub
 ::feeder-report-rich-content-list
 (fn [db [_]]
   (get-in db feeder-rich-content-list-path)))

(rf/reg-sub
 ::feeder-rich-text-completed-amount
 :<-
 [::feeder-report-rich-content-list]
 (fn [feeder-report-rich-content-list _]
   (resolve-submit-for-review-text feeder-report-rich-content-list)))

(rf/reg-sub
 ::holdings-report-rich-content-list
 (fn [db [_]]
   (get-in db holdings-rich-content-list-path)))

(rf/reg-sub
 ::rich-content-list-by-holding
 :<-
 [::holdings-report-rich-content-list]
 (fn [holdings-report-rich-content-list [_ holding-id]]
   (get holdings-report-rich-content-list holding-id)))

(rf/reg-sub
 ::holding-rich-text-completed-amount
 :<-
 [::holdings-report-rich-content-list]
 (fn [holdings-report-rich-content-list [_ holding-id]]
   (resolve-submit-for-review-text (get holdings-report-rich-content-list holding-id))))

(rf/reg-sub
 ::preview-mode?
 (fn [db _]
   (get db ::preview-mode? false)))

(rf/reg-sub
 ::pdf-preview-url
 (fn [db _]
   (get db ::pdf-preview-url)))
